import { Injectable } from '@angular/core';
import { BaseReportActionsHandler } from '../base-report-actions-handler';
import * as _ from 'underscore';
import { util } from '../../../util';
import { IObject } from '../../../../../type_definitions/datatypes';
import { Override } from '../../../app-decorators';

export const ROW_TIER_STATUS: string = 'Detiest_ds';

@Injectable()
export class OEMTierStatusPreconditionService extends BaseReportActionsHandler {
  private allowedTierStatuses: string[] = ['Distributor', 'Direct'];

  @Override(BaseReportActionsHandler)
  public execute(): Promise<string | void> {
    if (this.isTierStatusMixed()) {
      return Promise.reject('Please select rows with the same tier status (distributor or direct)');
    }

    return Promise.resolve();
  }

  private isTierStatusMixed(): boolean {
    return _.chain<IObject[]>(Object.values(this.rowSelection))
      .map((row: IObject) => util.extractValue(row?.[ROW_TIER_STATUS]))
      .filter((tierStatus: string) => _.contains(this.allowedTierStatuses, tierStatus))
      .uniq()
      .value().length !== 1;
  }
}